import {Store, StoreConfig} from "@datorama/akita";
import {Injectable} from "@angular/core";
import {AppData} from "../../shared/models/AppData";

export type AppState = AppData;

function createInitialState(): AppState {
  return {
    languages: [],
    countries: [],
    nationalities: [],
    residences: [],
    interventionRequests: [],
  };
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'app'
})
export class AppStore extends Store<AppState> {
  constructor() {
    super(createInitialState());
  }
}
